<template>
  <div class="asset-view-wrapper">
    <div class="assets-table-container">
      <!-- Zakładki -- kolejne fazy (konsola MQTT, zdrowie floty...) dokładają tu kolejne -->
      <Tabs>
        <template #tab-selector>
          <button
            :class="{ active: activeTab === 'network' }"
            class="tab-link"
            @click="activeTab = 'network'"
          >
            {{ $t('components.infrastructure.tabs.network') }}
          </button>
          <button
            :class="{ active: activeTab === 'topology' }"
            class="tab-link"
            @click="activeTab = 'topology'"
          >
            {{ $t('components.infrastructure.tabs.topology') }}
          </button>
          <button
            :class="{ active: activeTab === 'anchorPlacement' }"
            class="tab-link"
            @click="activeTab = 'anchorPlacement'"
          >
            {{ $t('components.infrastructure.tabs.anchorPlacement') }}
          </button>
          <button
            :class="{ active: activeTab === 'fleetHealth' }"
            class="tab-link"
            @click="activeTab = 'fleetHealth'"
          >
            {{ $t('components.infrastructure.tabs.fleetHealth') }}
          </button>
          <button
            :class="{ active: activeTab === 'dataCleanup' }"
            class="tab-link"
            @click="activeTab = 'dataCleanup'"
          >
            {{ $t('components.infrastructure.tabs.dataCleanup') }}
          </button>
          <button
            :class="{ active: activeTab === 'mqttConsole' }"
            class="tab-link"
            @click="activeTab = 'mqttConsole'"
          >
            {{ $t('components.infrastructure.tabs.mqttConsole') }}
          </button>
        </template>
        <template #tab-content>
          <div v-show="activeTab === 'network'">
            <WirepasNetworkGrid :active="activeTab === 'network'" />
          </div>
          <div v-show="activeTab === 'topology'">
            <WirepasTopologyGraph :active="activeTab === 'topology'" />
          </div>
          <div v-show="activeTab === 'anchorPlacement'">
            <WirepasAnchorPlacementGrid :active="activeTab === 'anchorPlacement'" />
          </div>
          <div v-show="activeTab === 'fleetHealth'">
            <WirepasFleetHealthGrid :active="activeTab === 'fleetHealth'" />
          </div>
          <div v-show="activeTab === 'dataCleanup'">
            <WirepasDataCleanupGrid :active="activeTab === 'dataCleanup'" />
          </div>
          <div v-show="activeTab === 'mqttConsole'">
            <WirepasMqttConsoleGrid :active="activeTab === 'mqttConsole'" />
          </div>
        </template>
      </Tabs>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import Tabs from '@/components/extras/Tabs.vue'
import WirepasNetworkGrid from '@/components/content/WirepasNetworkGrid.vue'
import WirepasTopologyGraph from '@/components/content/WirepasTopologyGraph.vue'
import WirepasAnchorPlacementGrid from '@/components/content/WirepasAnchorPlacementGrid.vue'
import WirepasFleetHealthGrid from '@/components/content/WirepasFleetHealthGrid.vue'
import WirepasDataCleanupGrid from '@/components/content/WirepasDataCleanupGrid.vue'
import WirepasMqttConsoleGrid from '@/components/content/WirepasMqttConsoleGrid.vue'

export default defineComponent({
  name: 'InfrastructureView',
  components: { Tabs, WirepasNetworkGrid, WirepasTopologyGraph, WirepasAnchorPlacementGrid, WirepasFleetHealthGrid, WirepasDataCleanupGrid, WirepasMqttConsoleGrid },
  emits: ['pageName'],

  setup(_, { emit }) {
    const { t } = useI18n()
    const activeTab = ref('network')

    emit('pageName', t('aside.menu.pages.infrastructure'))

    return { activeTab }
  },

  watch: {
    '$i18n.locale'() {
      this.$emit('pageName', this.$t('aside.menu.pages.infrastructure'))
    },
  },
})
</script>
